<template>
    <div class="website flex">
        <div class="ff">
            <h3 class="resource-title">
                {{configuration.title}}
            </h3>
            <div class="resource-description" v-if="configuration.metadata.description">
                {{configuration.metadata.description}}
            </div>
            <div class="flex">
                <a :href="configuration.metadata.url" target="_blank" class="button external flex flex-align">
                    Open Website
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-external-link" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z"/>
                        <path d="M11 7h-5a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-5" />
                        <line x1="10" y1="14" x2="20" y2="4" />
                        <polyline points="15 4 20 4 20 9" />
                    </svg>
                </a>
            </div>
        </div>
        <div class="resource-summary-thumbnail" v-if="configuration.metadata.thumbnail && !this.configuration.data.thumbnails">
            <img :src="configuration.metadata.thumbnail" />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Website',
        props: {
            configuration: Object
        },
        computed: {

        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .website
    {
        margin: 50px 0;
        max-width: 800px;
        padding: 30px;
        border: 1px solid @e4;
        border-radius: 5px;

        .resource-title
        {
            font-size: 22px;
            line-height: 26px;
            margin: 12px 0 6px;
        }

        .resource-description
        {
            font-size: 15px;
            line-height: 20px;
            margin-bottom: 20px;
            color: @grey;
        }

        .button.external
        {
            padding-right: 12px;

            .icon
            {
                width: 19px;
                margin-left: 10px;
            }
        }

        .thumbnails
        {
            margin-top: 20px;
        }

        .thumbnail
        {
            width: 120px;
            height: 120px;
            box-shadow: 0 3px 10px -2px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1);
            margin-right: 20px;
            border-radius: 5px;
            overflow: hidden;
            margin-top: 20px;

            img
            {
                width: 120px;
                height: 120px;
                object-fit: cover;
            }
        }

        .resource-summary-thumbnail
        {
            margin-left: 20px;

            img
            {
                width: 120px;
                height: 120px;
                border-radius: 6px;
                box-shadow: 0 6px 20px -2px rgba(0, 0, 0, 0.25);
                object-fit: cover;
            }
        }
    }

    .button.external
    {
        padding-right: 12px;

        .icon
        {
            width: 19px;
            margin-left: 10px;
        }
    }
</style>
